var map = {
	"./argentina-kit.webp": 20309,
	"./australia-kit.webp": 20570,
	"./benetton-kit.webp": 65715,
	"./benetton-rugby-kit.webp": 68957,
	"./blue-bulls-kit.webp": 96885,
	"./boland-kavaliers-kit.webp": 38931,
	"./bristol-bears-kit.webp": 28013,
	"./bulls-kit.webp": 65370,
	"./cardiff-kit.webp": 29085,
	"./cardiff-rugby-kit.webp": 34587,
	"./chile-kit.webp": 64205,
	"./connacht-kit.webp": 12232,
	"./connacht-rugby-kit.webp": 43974,
	"./default-kit.webp": 63809,
	"./dhl-stormers-kit.webp": 61086,
	"./dragons-kit.webp": 50404,
	"./dragons-rfc-kit.webp": 19528,
	"./edinburgh-kit.webp": 50288,
	"./edinburgh-rugby-kit.webp": 40814,
	"./emirates-lions-kit.webp": 60984,
	"./england-kit.webp": 59309,
	"./figi-kit.webp": 33719,
	"./france-kit.webp": 26549,
	"./georgia-kit.webp": 34208,
	"./glasgow-warriors-kit.webp": 31732,
	"./glasgow-warriors-rugby-kit.webp": 16778,
	"./golden-lions-kit.webp": 62797,
	"./griquas-kit.webp": 83010,
	"./hollywoodbets-sharks-kit.webp": 79108,
	"./ireland-kit.webp": 16115,
	"./italy-kit.webp": 96595,
	"./japan-kit.webp": 55260,
	"./leinster-kit.webp": 54614,
	"./leinster-rugby-kit.webp": 33240,
	"./lions-kit.webp": 87271,
	"./munster-kit.webp": 1523,
	"./munster-rugby-kit.webp": 57246,
	"./new-zealand-kit.webp": 25762,
	"./northampton-saints-kit.webp": 65919,
	"./ospreys-kit.webp": 72087,
	"./portugal-kit.webp": 79592,
	"./pumas-kit.webp": 22974,
	"./samoa-kit.webp": 54663,
	"./scarlets-kit.webp": 55017,
	"./scotland-kit.webp": 69674,
	"./sharks-kit.webp": 43136,
	"./sharks-xv-kit.webp": 27987,
	"./south-africa-kit.webp": 8968,
	"./spain-kit.webp": 58845,
	"./stormers-kit.webp": 20541,
	"./tonga-kit.webp": 92217,
	"./toyota-cheetahs-kit.webp": 21802,
	"./ulster-rugby-kit.webp": 2149,
	"./uruguay-kit.webp": 69648,
	"./usa-kit.webp": 91667,
	"./vodacom-bulls-kit.webp": 79754,
	"./wales-kit.webp": 17164,
	"./western-province-kit.webp": 92351,
	"./zebre-parma-kit.webp": 85820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67913;